/* AUREUS / cosmetic Outlink button text only.
   Keeps Outlink's unique URL, variant logic, click handler and analytics intact. */
(function () {
  function tidyLabel(button) {
    if (!button) return;
    var before = (button.textContent || '').replace(/\s+/g, ' ').trim();
    if (!before) return;

    // Keep Outlink's partner name; replace the legacy text arrow with carousel icon via CSS.
    var cleaned = before.replace(/\s*[❯›→↗➔➜]\s*$/, '').trim();
    var after = cleaned.replace(/^buy\s+from\s+/i, 'Shop at ');

    if (after && before !== after) button.textContent = after;
    if (after) button.setAttribute('data-ab-cta-ready', '1');
  }

  function init() {
    document.querySelectorAll('[data-ab-outlink-assurance]').forEach(function (note) {
      var id = note.getAttribute('data-outlink-id');
      var button = id ? document.getElementById(id) : null;
      if (!button || button.tagName !== 'A') {
        note.hidden = true;
        return;
      }

      tidyLabel(button);
      // Outlink may update its label when variants change; modify text only.
      var observer = new MutationObserver(function () { tidyLabel(button); });
      observer.observe(button, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
